<div fxLayout="column" fxFlex="100" fxLayoutGap="15px">
      <mat-card fxLayout="column" fxLayoutGap="15px" fxFlex="100">
        <div fxLayout="column">
          <h3>Dodaj użytkownika</h3>
          <div fxLayout="row" fxLayoutGap="15px">
            <div fxFlex="100">
              <app-dict-users fxFlex="100" label="Użytkownik" [control]="userControl" [userFormsPermission]="true" [userFilter]="'ROLE_ASF360'" (selectedUser)="userChanged($event)"></app-dict-users>
            </div>
          </div>
        </div>
        <div fxFlex="100" fxLayout="row">
          <div fxFlex="100" fxLayoutGap="15px">
            <mat-form-field fxFlex="100" >
              <mat-label> Adres e-mail </mat-label>
              <input (keyup.enter)="addMail()" name="userEmail"  matInput placeholder="Adres Mailowy"  [formControl]="userEmailControl" >
              <mat-error></mat-error>
            </mat-form-field>
          </div>
        </div>

      </mat-card>
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <div fxLayout="row" fxFlex="100" fxLayoutAlign="end" fxLayoutGap="15px">
    <button (click)="addMail()" mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
    </div>
  </div>
  </div>
